import { render, staticRenderFns } from "./AllMenu.vue?vue&type=template&id=5b3f9921&scoped=true"
import script from "./AllMenu.vue?vue&type=script&lang=js"
export * from "./AllMenu.vue?vue&type=script&lang=js"
import style0 from "./AllMenu.vue?vue&type=style&index=0&id=5b3f9921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f9921",
  null
  
)

export default component.exports